import { ColDef } from "ag-grid-community";
import { DatosEmpleadosService } from "../services/mantenimiento/datos-empleados.service";
import { stringComparator } from "src/app/shared/utils/ag-grid-comparators";

export class GridColDefsEmpleados{

  constructor(private datosEmpleadosService: DatosEmpleadosService){}

  columnDefs: ColDef[] = [
    { headerName:"Código", field: "codigo", sortable:true, resizable:true, headerClass:"header", width: 250, headerCheckboxSelection: this.datosEmpleadosService.consultaEmpleados ? false : true,
    checkboxSelection: this.datosEmpleadosService.consultaEmpleados ? false : true},
    { headerName:"Nombre", field: "nombre", sortable:true, resizable:true, headerClass:"header", width: 180,
      comparator: stringComparator
    },
    { headerName:"Apellido 1", field: "apellido1", sortable:true, resizable:true, headerClass:"header", width: 180,
      comparator: stringComparator
    },
    { headerName:"Apellido 2", field: "apellido2", sortable:true, resizable:true, headerClass:"header", width: 180,
      comparator: stringComparator
    },
    { headerName:"Nif", field: "nif", sortable:true, resizable:true, headerClass:"header", width: 150 },
    { headerName:"Empresa", field: "nombreEmpresa", sortable:true, resizable:true, headerClass:"header", width: 300,
      comparator: stringComparator,
      cellRenderer: params => {
        let codigoEmpresaGrid = (params.data.codigoEmpresa == null || params.data.codigoEmpresa.toUpperCase()=='NULL') ? '' : params.data.codigoEmpresa;
        let nombreEmpresaGrid = (params.data.nombreEmpresa == null || params.data.nombreEmpresa.toUpperCase()=='NULL') ? '' : params.data.nombreEmpresa;
        return `${codigoEmpresaGrid} - ${nombreEmpresaGrid}`
      }
    },
    { headerName:"Centro", field: "nombreCentro", sortable:true, resizable:true, headerClass:"header", width: 300,
      cellRenderer: params => {
        let codigoCentroGrid = (params.data.codigoCentro == null || params.data.codigoCentro.toUpperCase()=='NULL') ? '' : params.data.codigoCentro;
        let nombreCentroGrid = (params.data.nombreCentro == null || params.data.nombreCentro.toUpperCase()=='NULL') ? '' : params.data.nombreCentro;
        return `${codigoCentroGrid} - ${nombreCentroGrid}`
      }
    }
  ];
}
